import React from 'react';
import styled from 'styled-components';
import { IVR_TREE_TOP_MARGIN } from 'src/presentation/components/pages/ivr/constants/ivrConstants';
import { Tooltip } from 'src/presentation/components/agent_desktop_components';

export enum ToolbarOrientation {
  VERTICAL,
  HORIZONTAL,
}

type ToolbarProps = {
  orientation?: ToolbarOrientation;
  children?: any;
};

export const Toolbar = ({ orientation = ToolbarOrientation.VERTICAL, children }: ToolbarProps) => {
  return (
    <ToolbarWrapper orientation={orientation} onClick={e => e.stopPropagation()}>
      {children}
    </ToolbarWrapper>
  );
};

type ToolbarBtnProps = {
  disabled?: boolean;
  hint: string;
  onClick: Function;
  svg: any;
};

export const ToolbarBtn = ({ svg, onClick, disabled, hint }: ToolbarBtnProps) => {
  const Svg = svg;
  return (
    <ToolbarBtnWrapper disabled={disabled} onClick={e => onClick && !disabled && onClick(e)}>
      <Tooltip message={hint} margin={18} position="right">
        <Svg width={16} height={16} />
      </Tooltip>
    </ToolbarBtnWrapper>
  );
};

const ToolbarBtnWrapper = styled.div`
  cursor: pointer;
  fill: ${p => (p.disabled ? p.theme.colors.gray300 : '')};
  padding: 14px;
  &:hover {
    fill: ${p => (!p.disabled ? p.theme.colors.green400 : p.theme.colors.gray300)};
  }
`;

export const ToolbarWrapper = styled.div`
  background: ${p => p.theme.colors.white};
  border-radius: 10px;
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.04), 0px 0px 10px rgba(0, 0, 0, 0.06), 0px 0px 80px rgba(0, 0, 0, 0.06);
  display: flex;
  flex-direction: row;
  position: absolute;
  top: calc(50% - ${IVR_TREE_TOP_MARGIN});

  width: 100px;
  justify-content: center;

  ${p => (p.orientation === ToolbarOrientation.VERTICAL ? 'transform: rotate(90deg);' : '')};
  ${ToolbarBtnWrapper} {
    ${p => (p.orientation === ToolbarOrientation.VERTICAL ? 'transform:rotate(-90deg);' : '')};
  }
`;
